export type AuthorizationErrorCode =
  | 'MissingAuthorizationCode'
  | 'StateMismatch'
  | 'MissingCodeVerifier'
  | 'NonceMismatch';

/**
 * An error that occurs during the authorization flow.
 * Includes a code to indicate the nature of the authorization error
 */
export class AuthorizationError extends Error {
  constructor(code: AuthorizationErrorCode, message: string) {
    super(`${code} - ${message}`);
  }
}
